import kr from 'Kr/kr';
import HTMLCLass from '../../kr/utils/HTMLClass';

export default class Popup extends kr.Component {
    init() {
        this.$close = this.$element.querySelector('.js-popup-close');
        this.selectors = this.$element.getAttribute('data-selectors');

        if (!this.selectors) {
            return;
        }
        this.selectors = this.selectors.split(',');
        this.bind();
    }

    bind() {
        for (let i in this.selectors) {
            const selector = this.selectors[i];
            if (selector == 'autorun') {
                HTMLCLass.addClass(this.$element, 'popup--opened');
                this.$element.style.display="block";
                continue;
            }
            const els = document.querySelectorAll(selector);
            if (!els) {
                continue;
            }
            for (let key in els) {
                if (!els.hasOwnProperty(key)) {
                    continue;
                }
                els[key].addEventListener('click', (event) => {
                    event.preventDefault();
                    HTMLCLass.addClass(this.$element, 'popup--opened');
                    this.$element.style.display="block";
                });
            }
        }
        this.on('click', '.js-popup-close', (target, event) => {
            event.preventDefault();
            this.$element.style.display="none";
            HTMLCLass.removeClass(this.$element, 'popup--opened');
        });
    }
}

kr.registerComponent('.js-popup', {
    component: Popup
});